export const closeTOC = () => {
  return { type: "CLOSE_TOC" };
};

export const changePage = (page, param) => {
  return { type: "CHANGE_PAGE", payload: { page, param } };
};

export const pageLoaded = (loadedPage, linkedPages, hasVideo) => {
  return {
    type: "PAGE_LOADED",
    payload: { loadedPage, linkedPages, hasVideo },
  };
};
export const pageUnloaded = (page) => {
  return { type: "PAGE_UNLOADED", payload: { page } };
};

export const pageState = (page, state) => {
  return { type: "PAGE_STATE", payload: { page, state } };
};

export const toggleThumbnailDrawer = (bool) => {
  return { type: "TOGGLE_THUMBNAIL_DRAWER", payload: bool };
};
